@if (isBrowser) {
<div class="d-flex align-items-center">
  @if (showIcon) {
  <img src="assets/icons/icons-alt/calendar-04.svg" class="pe-1" alt="Calendar"/>
  }

  @if (displayDay) {
  <span [innerHTML]="start ? (start | date:'d') : ''"></span><span>&nbsp;</span>
  }

  @if (haveDifferentMonths()) {
  <span [innerHTML]="start ? formatDate(start!) : ''"></span><span>&nbsp;</span>
  }

  @if (haveDifferentYears()) {
  <span [innerHTML]="start ? (start | date:'yyyy') : ''"></span><span>&nbsp;</span>
  }

  @if (checkSameDate()) {
    @if (displayDay) {
      <span>-</span><span>&nbsp;</span>
      @if (haveDifferentDaysOnly()) {
        <span [innerHTML]="end ? (end | date:'d') : ''"></span><span>&nbsp;</span>
      }
    } @else if (haveDifferentMonths() || haveDifferentYears()) {
      <span>-</span><span>&nbsp;</span>
    }
  }

  @if (haveDifferentMonths()) {
    <span [innerHTML]="end ? formatDate(end!) : ''"></span>
  } @else if (!checkSameDate()) {
    <span [innerHTML]="start ? formatDate(start!) : ''"></span>
  } @else {
    <span [innerHTML]="start ? formatDate(start!) : ''"></span>
  }

  <span>&nbsp;</span>

  @if (haveDifferentYears()) {
  <span [innerHTML]="end ? (end | date:'yyyy') : ''"></span>
  } @else {
  <span [innerHTML]="start ? (start | date:'yyyy') : ''"></span>
  }
</div>
}
